var module = angular.module('octopusApp.dashboard');

module.controller('DashboardConfigureController', function ($scope, $timeout, busy, octopusRepository, $location){
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  $scope.radios = {};
  $scope.selectedTenants = [];
  $scope.selectedTags = [];

  isLoading.promise(octopusRepository.DashboardConfiguration.get().then(function (configuration) {
    isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
      isLoading.promise(octopusRepository.Projects.all().then(function (projects) {
        isLoading.promise(octopusRepository.ProjectGroups.all().then(function (projectGroups) {
          var projectGroupNamesById = {};
          _.each(projectGroups, function (projectGroup) { projectGroupNamesById[projectGroup.Id] = projectGroup.Name; });

          $scope.projects = _.map(projects, function (proj) { return { Id: proj.Id, Sort: proj.Name, Group: projectGroupNamesById[proj.ProjectGroupId], Name: proj.Name }; });
          $scope.environments = _.map(environments, function (env) { return { Id: env.Id, Group: "", Sort: env.SortOrder, Name: env.Name }; });
          $scope.configuration = configuration;

          $scope.radios.isAllProjects = configuration.IncludedProjectIds.length === 0 ? "true" : "false";
          $scope.radios.isAllEnvironments = configuration.IncludedEnvironmentIds.length === 0 ? "true" : "false";
        }));
      }));
    }));
  }));

  $scope.save = function() {
    if ($scope.radios.isAllProjects === "true") {
      $scope.configuration.IncludedProjectIds = [];
    }
    if ($scope.radios.isAllEnvironments === "true") {
      $scope.configuration.IncludedEnvironmentIds = [];
    }

    isSaving.promise(octopusRepository.DashboardConfiguration.modify($scope.configuration).then(function (config) {
      $location.path("/");
    }));
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/dashboard/controllers/dashboard_configure_controller.js
// module id = 413
// module chunks = 1